import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { PngIcon, SvgIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './ClubAccessRestrictionPopup.module.css';

type ClubAccessRestrictionPopupProps = {
  onDetails: () => void;
  onCancel: () => void;
  type?: 'general' | 'subscription' | 'senClub';
};

export const ClubAccessRestrictionPopup = (
  props: ClubAccessRestrictionPopupProps,
) => {
  const { t } = useTranslation();
  const { onDetails, onCancel, type = 'subscription' } = props;

  let buttonLabel;
  let description1;
  let description2;
  if (type === 'general') {
    buttonLabel = 'Web Store';
    description1 = 'You would need further permission to access this feature.';
    description2 = 'Please visit Web Store to learn more.';
  } else if (type === 'subscription') {
    buttonLabel = 'Subscription';
    description1 = 'You would need further permission to access this feature.';
    description2 = 'Please visit Subscription Page to learn more.';
  } else {
    buttonLabel = 'Course Webpage';
    description1 = 'Access to this space requires permission.';
    description2 = 'Please visit the course webpage for details.';
  }

  return (
    <BasicPopupContainer
      primaryButtonLabel={t(buttonLabel)}
      onPrimaryButtonClick={onDetails}
      onSecondaryButtonClick={onCancel}
    >
      <div className={styles.popupContent}>
        <div className={styles.noticeIcon}>
          {type === 'senClub' ? (
            <PngIcon name="Notice" width={80} height={80} />
          ) : (
            <SvgIcon
              name={
                type === 'general'
                  ? SVGIconType.Upgrade
                  : SVGIconType.SubscriptionUpgrade
              }
              height={80}
              width={80}
            />
          )}
        </div>
        <div className={styles.description}>{t(description1)}</div>
        <div className={styles.description}>{t(description2)}</div>
      </div>
    </BasicPopupContainer>
  );
};
